import React, { useState, useEffect } from 'react'
import { useAuthState } from "react-firebase-hooks/auth"
import { db, auth } from "../../assets/js/firebase"
import { collection, query, where, getDocs, orderBy, onSnapshot, and, or, limit, getDoc, doc, updateDoc } from 'firebase/firestore'
import { useNavigate, useParams } from "react-router-dom"
import noImage from '../../assets/images/no-image-icon.png'
import Drawer from '@mui/material/Drawer'
import Box from '@mui/material/Box'
import { getBrand as getWashBrand, getModel as getWashModel } from '../helper/BrandWashHelper'

import Slider from '@mui/material/Slider'
import './../home/Home2.css'
import './Post.css'
import Pagination from '@mui/material/Pagination'

const Posts = () => {
    const params = useParams()
    const navigate = useNavigate()
    const number_format = new Intl.NumberFormat()
    const [user, loading, error] = useAuthState(auth)

    const [uid, setUid] = useState('')
    const [docId, setDocId] = useState('')
    const [board, setBoard] = useState(4)
    const [keywordBrand, setKeywordBrand] = useState('')
    const [keywordModel, setKeywordModel] = useState('')

    const [posts, setPosts] = useState([])
    const [washBrand, setWashBrand] = useState([])
    const [searchWashBrand, setSearchWashBrand] = useState([])
    const [minPrice, setMinPrice] = useState(0)
    const [maxPrice, setMaxPrice] = useState(99999999)
    const [sliderValue, setSliderValue] = useState([0, 99999999])
    const [openDrawer, setOpenDrawer] = useState(false)

    const onMobile = window.innerWidth < 920
    var imagePostHeight = 190
    var thumpnailWidth = 100
    var h1FontSize = 42
    var h2FontSize = 24
    var h3FontSize = 18
    var textFontSize = 16
    var numRowPost = 3
    var fontSizeHeadSide = 30

    if(window.innerWidth < 920 && window.innerWidth >= 576) {
        imagePostHeight = 150
        thumpnailWidth = 80
        h1FontSize = 32
        h2FontSize = 20
        h3FontSize = 18
        textFontSize = 16
        numRowPost = 2
        fontSizeHeadSide = 20
    } else if(window.innerWidth < 576) {
        imagePostHeight = 100
        thumpnailWidth = 60
        h1FontSize = 24
        h2FontSize = 18
        h3FontSize = 14
        textFontSize = 14
        numRowPost = 2
        fontSizeHeadSide = 20
    }

    const [width, setWidth] = useState(100)
    const [height, setHeight] = useState(imagePostHeight)
    const [widthImageShop, setWidthImageShop] = useState(100)
    const [heightImageShop, setHeightImageShop] = useState(100)

    const [postsPage, setPostsPage] = useState([])
    const [page, setPage] = useState(1)
    
    const dateFormat = (datetime) => {
        const date_string = new Date(datetime).toLocaleDateString("th-TH")
        const time_string = new Date(datetime).toLocaleTimeString("th-TH")
        const time = time_string.split(':')
        return date_string+" "+time[0]+":"+time[1]
    }

    const clickShopAds = (position, id) => {
        getDoc(doc(db, `ads/active/position_${position}`, id)).then(async(adsDoc) => {
            var click = 1
            if(adsDoc.data().click) {
                click = adsDoc.data().click + 1
            }
            updateDoc(doc(db, `ads/active/position_${position}`, id), {
                click: click
            }).then(() => {
                navigate(`/shop/history/${adsDoc.data().shop_id}`)
            })
        })
    }

    const [adsPosition10List, setAdsPosition10List] = useState([])

    const fetchAdsPosition10 = () => {
        adsPosition10List.splice(0, adsPosition10List.length)
        setAdsPosition10List([...adsPosition10List])
        onSnapshot(query(collection(db, `ads/active/position_10`), where('status', '==', 1), orderBy('active_date', 'asc'), limit(10)), (result) => {
            result.forEach(async(ads) => {
                getDoc(doc(db, `shops/`, ads.data().shop_id)).then(async(shopDoc) => {
                    var province = 'ไม่ระบุ'
                    var district = 'ไม่ระบุ'
                    var promisesTask = []

                    if(shopDoc.data().province) {
                        var provinceTask = getDocs(query(collection(db, 'provinces'), where('province_id', '==', shopDoc.data().province * 1))).then((docs) => {
                            if(docs.docs.length > 0) { province = docs.docs[0].data().province_name }
                        })
                        promisesTask.push(provinceTask)
                    }

                    if(shopDoc.data().district) {
                        var districtTask = getDocs(query(collection(db, 'distrincts'), where('district_id', '==', shopDoc.data().district))).then((docs) => {
                            if(docs.docs.length > 0) { district = docs.docs[0].data().district_name }
                        })
                        promisesTask.push(districtTask)
                    }

                    var images = []
                    var imagesTask = await getDocs(query(collection(db, `shops/${ads.data().shop_id}/images`))).then((imageDocs) => {
                        imageDocs.docs.forEach((image) => {
                            images.push({
                                id: image.id,
                                data: image.data()
                            })
                        })
                    })
                    promisesTask.push(imagesTask)

                    getDocs(query(collection(db, `appointments/`), where('shop_id', '==', ads.data().shop_id))).then((appointments) => {
                        Promise.all(promisesTask).then(() => {
                            adsPosition10List.push({
                                id: ads.id,
                                data: ads.data(),
                                shop: shopDoc.data(),
                                province: province,
                                district: district,
                                appointment: appointments.docs.length,
                                images: images
                            })
                            setAdsPosition10List([...adsPosition10List], {
                                id: ads.id,
                                data: ads.data(),
                                shop: shopDoc.data(),
                                province: province,
                                district: district,
                                appointment: appointments.docs.length,
                                images: images
                            })
                        })
                    })
                })
            })
        })
    }

    const handleSearch = () => {
        const constraints = []
        const order = []
        constraints.push(where('onboard', '==', 2))
        constraints.push(or(where('status', '==', 1), where('status', '==', 2)))
        if(searchWashBrand.length > 0) {
            constraints.push(or(where('wash1_brand_id', 'in', searchWashBrand), where('wash2_brand_id', 'in', searchWashBrand)))
        }
        order.push(orderBy('post_timestamp', 'desc'))
        if(constraints.length >= 2) {
            var postQuery = query(collection(db, 'cleans'), and(...constraints), ...order)
        } else {
            var postQuery = query(collection(db, 'cleans'), ...constraints, ...order)
        }
        onSnapshot(postQuery, (querySnapshot) => {
            postsPage.splice(0, postsPage.length)
            setPostsPage([...postsPage])
            posts.splice(0, posts.length)
            setPosts([...posts])
            querySnapshot.forEach((doc) => {
                var brand1 = 'ไม่ระบุ'
                var model1 = 'ไม่ระบุ'
                var brand2 = 'ไม่ระบุ'
                var model2 = 'ไม่ระบุ'
                var promisesTask = []
                if(doc.data().wash_type1) {
                    var getBrand1Task = getWashBrand(db, doc.data().wash1_brand_id, doc.data().wash1_brand).then((brandName) => {
                        brand1 = brandName
                    })
                    promisesTask.push(getBrand1Task)
    
                    var getModel1Task = getWashModel(db, doc.data().wash1_model_id, doc.data().wash1_model).then((modelName) => {
                        model1 = modelName
                    })
                    promisesTask.push(getModel1Task)
                }
                if(doc.data().wash_type2) {
                    var getBrand2Task = getWashBrand(db, doc.data().wash2_brand_id, doc.data().wash2_brand).then((brandName) => {
                        brand2 = brandName
                    })
                    promisesTask.push(getBrand2Task)
    
                    var getModel2Task = getWashModel(db, doc.data().wash2_model_id, doc.data().wash2_model).then((modelName) => {
                        model2 = modelName
                    })
                    promisesTask.push(getModel2Task)
                }

                Promise.all(promisesTask).then(() => {
                    posts.push({
                        id: doc.id,
                        data: doc.data(),
                        brand1: brand1,
                        model1: model1,
                        brand2: brand2,
                        model2: model2,
                    })
                    setPosts([...posts], {
                        id: doc.id,
                        data: doc.data(),
                        brand1: brand1,
                        model1: model1,
                        brand2: brand2,
                        model2: model2,
                    })

                    const postsSlide = posts.slice(0, 18)
                    setPostsPage(postsSlide)
                })
            })
        })
    }

    const handleSearchByBrand = (id) => {
        const others = Array.from(
            document.getElementsByClassName('brand-other')
        )
        const allBrand = Array.from(
            document.getElementsByClassName('brand-all')
        )
        if(id == 0) {
            searchWashBrand.splice(0, searchWashBrand.length)
            setSearchWashBrand([...searchWashBrand])
            allBrand.forEach(element => {
                element.checked = true
            })
            others.forEach(element => {
                element.checked = false
                element.removeAttribute('checked')
            })
        } else {
            if(searchWashBrand.indexOf(id) < 0) {
                searchWashBrand.push(id)
            } else {
                searchWashBrand.splice(searchWashBrand.indexOf(id), 1)
            }
            setSearchWashBrand([...searchWashBrand])
            if(searchWashBrand.length > 0) {
                allBrand.forEach(element => {
                    element.checked = false
                    element.removeAttribute('checked')
                })
            } else {
                allBrand.forEach(element => {
                    element.checked = true
                })
            }
        }
        handleSearch()
    }

    const getWashBrandList = () => {
        getDocs(query(collection(db, 'wash_brands'))).then((docs) => {
            setWashBrand(docs.docs.map(doc => ({
                id: doc.id,
                data: doc.data()
            })))
        })
    }

    const getDocUser = async () => {
        getDocs(query(collection(db, "users"), where("uid", "==", user.uid))).then((docs) => {
            if (docs.docs.length === 1) {
                const data = docs.docs[0].data()
                setDocId(docs.docs[0].id)
                if(data.uid) setUid(data.uid)
            }
        }).catch((error) => {
            alert(error.message)
        })
    }

    const fetchPosts = async () => {
        try {
            handleSearch()
        } catch (err) {
            alert(err.message)
        }
    }

    const handlePage = (event, value) => {
        const postsSlide = posts.slice(((value-1)*18), (((value-1)*18)+18))
        setPostsPage(postsSlide)
        setPage(value)
    }

    useEffect(() => {
        if (loading) return;
        if (user) getDocUser()
        fetchPosts()
        getWashBrandList()
        fetchAdsPosition10()
    }, [user, loading])

    const resizeDiv = new ResizeObserver((event) => {
        setWidth(event[0].contentBoxSize[0].inlineSize-1)
        setHeight(imagePostHeight)
    })

    useEffect(() => {
        resizeDiv.observe(document.getElementById("divPost"))
    })
    
    const toggleDrawer = (newOpen) => () => {
        setOpenDrawer(newOpen)
    }

    return (
        <>
            <Drawer open={openDrawer} onClose={toggleDrawer(false)}>
                <Box sx={{ width: 280 }} role="presentation">
                    <div style={{ display: 'flex', flexDirection: 'column', width: 250, marginLeft: 20 }}>
                        <div style={{ display: 'flex', flexDirection: 'column', width: 250, paddingTop: 15, paddingLeft: 10 }}>
                            <div style={{ display: 'flex', flexDirection: 'column' }}><font style={{ fontSize: h2FontSize, fontWeight: "600" }}>ค้นหาประกาศ</font></div>
                            <div style={{ display: 'flex', flexDirection: 'column' }}><font style={{ fontSize: h3FontSize, fontWeight: "600" }}>ประเภท</font></div>
                            <div style={{ display: 'flex', flexDirection: 'column', paddingLeft: 10, paddingBottom: 10, paddingLeft: 10 }}>
                                <div><input className="form-check-input brand-all" type="checkbox" value="0" defaultChecked={true} onClick={ (e) => { handleSearchByBrand(e.target.value) }} /> ทั้งหมด</div>
                                {washBrand?.map((type, i) => (
                                <div style={{ whiteSpace: 'nowrap'}} key={type.id}><input className="form-check-input brand-other" type="checkbox" value={type.id} onClick={ (e) => { handleSearchByBrand(e.target.value) }} /> {type.data.name}</div>
                                ))}
                                <div><input className="form-check-input brand-other" type="checkbox" value="999" id="brandOther" onClick={ (e) => { handleSearchByBrand(e.target.value) }} /> อื่นๆ</div>
                            </div>
                        </div>
                    </div>
                </Box>
            </Drawer>
            <div className="container-fluid flex-container" style={{ marginTop: 10, paddingLeft: 20 }}>
                <div className="d-none d-md-block d-lg-block" style={{ display: 'flex', flexDirection: 'column', width: 250 }}>
                    <div style={{ display: 'flex', flexDirection: 'column', width: 250, marginLeft: 20 }}>
                        <div style={{ display: 'flex', flexDirection: 'column', width: 250, paddingTop: 15, paddingLeft: 10 }}>
                            <div style={{ display: 'flex', flexDirection: 'column' }}><font style={{ fontSize: h2FontSize, fontWeight: "600" }}>ค้นหาประกาศ</font></div>
                            <div style={{ display: 'flex', flexDirection: 'column' }}><font style={{ fontSize: h3FontSize, fontWeight: "600" }}>ประเภท</font></div>
                            <div style={{ display: 'flex', flexDirection: 'column', paddingLeft: 10, paddingBottom: 10, paddingLeft: 10 }}>
                                <div><input className="form-check-input brand-all" type="checkbox" value="0" defaultChecked={true} onClick={ (e) => { handleSearchByBrand(e.target.value) }} /> ทั้งหมด</div>
                                {washBrand?.map((type, i) => (
                                <div style={{ whiteSpace: 'nowrap'}} key={type.id}><input className="form-check-input brand-other" type="checkbox" value={type.id} onClick={ (e) => { handleSearchByBrand(e.target.value) }} /> {type.data.name}</div>
                                ))}
                                <div><input className="form-check-input brand-other" type="checkbox" value="999" id="brandOther" onClick={ (e) => { handleSearchByBrand(e.target.value) }} /> อื่นๆ</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <font style={{ fontSize: h1FontSize, fontWeight: "600" }}>แจ้งความต้องการล้างเครื่องซักผ้า</font>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <div className='d-block d-md-none d-lg-none' style={{ display: 'flex', fleDirection: 'row', marginTop: 'auto', marginBottom: 5, alignSelf: 'end', float: 'right' }}>
                            <div style={{ display: 'flex', flexDisplay: 'column', alignmentBaseline: 'baseline' }}>
                                <button type="button" className="btn btn-light" onClick={toggleDrawer(true)}>ค้นหา</button>
                            </div>
                        </div>
                        <div className='flex-container' style={{ paddingTop: 10, paddingBottom: 5, alignContent: 'center' }}>
                            <div style={{ marginLeft: 15, paddingTop: 5, marginRight: 10, display: 'flex', flex: 1 }}><strong>รายการที่ {(((page-1)*18)+1)} - {(page*18 > posts.length)?posts.length:page*18} จากทั้งหมด {number_format.format(posts.length)} ประกาศ</strong></div>
                            <Pagination style={{ fontFamily: 'Prompt', marginRight: 10 }} count={Math.ceil(posts.length/18)} page={page} onChange={handlePage} color="primary" showFirstButton showLastButton />
                        </div>
                    </div>
                    <div className='flex-container' style={{ flex: 1 }}>
                        <div id="divPost" style={{ display: 'flex', flex: 3, flexDirection: 'row', flexWrap: 'wrap', alignItems: 'center', alignContent: 'space-between', backgroundColor: '#FFFFFF', paddingTop: 10 }}>
                            {postsPage?.map((post, i) => (
                            <div style={{ display: 'flex', flexDirection: 'column', alignSelf: 'stretch', width: (width/numRowPost), padding: 5, marginBottom: 5, cursor: 'pointer' }} key={post.id} onClick={() => navigate(`/postclean/${post.id}`)}>
                                <div style={{ display: 'flex', flexDirection: 'column', flex: 1, backgroundColor: '#ffffff', borderRadius: 15 }}>
                                    <div style={{ alignContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                                        <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                            <img style={{ display: 'flex', objectFit: "cover", borderTopLeftRadius: 15, borderTopRightRadius: 15, maxWidth: (width/numRowPost), height: height }} src={post.data.picture} alt="APP3R" />
                                        </div>
                                    </div>
                                    <div style={{ justifyContent: 'start', alignItems: 'stretch', flexDirection: 'row', padding: 15, flex: 1 }}>
                                        <div className="cut-text text-15-ch" style={{ fontSize: 14, display: 'flex', flexDirection: 'column', alignSelf: 'flex-start', flex: 1 }}>
                                            <div className="truncate-overflow" style={{ fontSize: 14, fontWeight: '400', color: '#3D5598', marginBottom: 0 }}>
                                                {post.data.wash_type1 && (
                                                    <div>
                                                        <strong>บริการล้างเครื่องซักผ้าฝาบน</strong> <br/>
                                                        ยี่ห้อ {post.brand1} รุ่น: {post.model1}  <br/>
                                                        ขนาด 
                                                        {post.data.wash1_capacity == '1' && "ความจุ ไม่เกิน 15 กก."}
                                                        {post.data.wash1_capacity == '2' && "ความจุ 15 - 19 กก."}
                                                        {post.data.wash1_capacity == '3' && "ความจุ 19 - 22 กก."}
                                                        {post.data.wash1_capacity == '4' && "ความจุ 22 กก. ขึ้นไป"}  <br/>
                                                        จำนวน {post.data.wash1_amount} เครื่อง
                                                    </div>
                                                )}
                                                {post.data.wash_type2 && (
                                                    <div>
                                                        <strong>บริการล้างเครื่องซักผ้าฝาหน้า</strong> <br/>
                                                        ยี่ห้อ {post.brand2} รุ่น: {post.model2}  <br/>
                                                        ขนาด 
                                                        {post.data.wash2_capacity == '1' && "ความจุ ไม่เกิน 15 กก."}
                                                        {post.data.wash2_capacity == '2' && "ความจุ 15 - 19 กก."}
                                                        {post.data.wash2_capacity == '3' && "ความจุ 19 - 22 กก."}
                                                        {post.data.wash2_capacity == '4' && "ความจุ 22 กก. ขึ้นไป"}  <br/>
                                                        จำนวน {post.data.wash2_amount} เครื่อง
                                                    </div>
                                                )}
                                            </div>
                                            <font style={{ fontSize: 14, color: '#626167' }}>
                                                วันที่ประกาศ: {dateFormat(post.data.post_timestamp)}
                                            </font>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            ))}
                        </div>
                        <div id="divAds" style={{ display: 'flex', flex: 1, flexDirection: 'column', backgroundColor: '#FFFFFF', paddingTop: 10 }}>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <div style={{ flexDirection: 'column', backgroundColor: '#FF6F62', alignItems: 'center', alignContent: 'center', padding: 10 }}>
                                    <div style={{ textAlign: 'center' }}><font style={{ fontSize: fontSizeHeadSide, fontWeight: '600', color: '#ffffff' }}>บริการล้าง<br/>เครื่องซักผ้า</font></div>
                                </div>
                                <div id="divImageShop" style={{ display: 'flex', flexDirection: 'column', marginBottom: 15 }}>
                                {adsPosition10List?.map((shop, i) => (
                                    <div style={{ display: 'flex', flexDirection: 'row', cursor: 'pointer' }} key={i} onClick={() => { clickShopAds(10, shop.id) }}>
                                        <div style={{ flex: 3 }}>
                                            {(shop.images.length > 0) && 
                                            <img style={{ display: 'flex', objectFit: "contain", maxWidth: (widthImageShop/3), height: heightImageShop }} src={shop.images[0].data.url} alt="APP3R" />
                                            }
                                            {(shop.images.length == 0) && 
                                            <img style={{ display: 'flex', objectFit: "contain", maxWidth: (widthImageShop/3), height: heightImageShop }} src={noImage} alt="APP3R" />
                                            }
                                        </div>
                                        <div key={i} className="cut-text text-30-ch" style={{ padding: 5, flexDirection: 'row', fontSize: 14, marginTop: 5, marginLeft: 10, flexWrap: 'wrap', flex: 7 }}>
                                            <font style={{ color: '#3D5598', fontWeight: '600' }}>ร้าน/บริษัท: {(shop.shop.type == 2)?shop.shop.shopname:shop.shop.firstname+" "+shop.shop.lastname} </font><br/>
                                            <font style={{ color: '#3D5598', fontWeight: '600' }}>ที่ตั้ง: {shop.province} {shop.district}</font><br/>
                                            <font style={{ color: '#984740', fontWeight: '600' }}>คะแนน: {number_format.format(shop.shop.score_average)} </font><br/>
                                            <font style={{ color: '#626167' }}>ให้บริการไปแล้ว: {number_format.format(shop.appointment)} </font>
                                        </div>
                                    </div>
                                ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Posts